import { Report } from '@shared/enums/report.enum';

import { generatedEnvironment } from './environment.generated';
import { FeatureFlag, IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  environment: 'dev',
  production: false,
  hotjarId: undefined,
  useServiceWorkers: true,
  serviceWorkersCheckUpdatesMins: 15,
  enableServiceWorkerVerboseLogging: true,
  appInsightsConnectionString:
    'InstrumentationKey=630d1cf3-8ccc-4d33-b60c-325218f83792;IngestionEndpoint=https://australiasoutheast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://australiasoutheast.livediagnostics.monitor.azure.com/',
  sparkPlusApplicationId: '90c75511-b792-4e8a-80c2-276bcd5ee963',
  sparkPlusB2CTenant: 'libfinintroducerssbx',
  sparkPlusB2CUserFlow: 'B2C_1A_SPARKPLUSUI_SIGNIN',
  iqApplicationId: 'd96f51fe-c1e6-4d61-9a90-e4921eff8845',
  iqB2CTenant: 'libfinintroducerssbx',
  iqB2CUserFlow: 'B2C_1A_IQ_SIGNIN',
  iqRedirectUri: 'https://iq.sandbox-liberty.com.au/',
  clientsApiUrl: 'https://spcli.sandbox-liberty.com.au/',
  clientsApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  managementApiUrl: 'https://spmng.sandbox-liberty.com.au/',
  managementApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/spark/management-auth-api/user_impersonation'
  ],
  opportunityApiUrl: 'https://spopp.sandbox-liberty.com.au/',
  opportunityApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  libraryApiUrl: 'https://services.sandbox-liberty.com.au/api/aggregationplatform-library/',
  libraryApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/spark/library-api/user_impersonation'
  ],
  glassGuideApi: {
    url: 'https://motglass-search-dang21.search.windows.net/',
    key: 'YLXcZl8P8GWpUJ72A5xMJuVJICLkBQfqN8st0sngqyAzSeBNczz9'
  },
  googleMapsApi: {
    key: 'AIzaSyB6TZpSgbfQ0jBI4WkND9_49AySDRmMuAw'
  },
  iqAuthApiUrl: 'https://api-iq.sandbox-liberty.com.au/auth/',
  iqAuthApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/iq/auth-api/user_impersonation'
  ],
  libertyGatewayUrl: 'https://api-iq.sandbox-liberty.com.au/',
  opportunityDocumentApiUrl:
    'https://services.sandbox-liberty.com.au/api/spark-document-storage/',
  opportunityDocumentApiScopes: [
    'https://libfinintroducerssbx.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  iqWebUrl: 'https://iq.sandbox-liberty.com.au',
  features: {
    [FeatureFlag.OpportunitySubmission]: true,
    [FeatureFlag.OpportunityESignPAPP]: true,
    [FeatureFlag.OpportunityMoneyplaceBorrowCapacity]: true,
    [FeatureFlag.ProductMatrix]: true,
    [FeatureFlag.Kyc]: true,
    [FeatureFlag.ContactDeletion]: true,
    [FeatureFlag.ContactReassignment]: true,
    [FeatureFlag.Reports]: true,
    [FeatureFlag.Insurance]: true,
    [FeatureFlag.Refix]: true,
    [FeatureFlag.CommercialMotor]: true,
    [FeatureFlag.AliGroupInsurance]: true,
    [FeatureFlag.LnsPanelLenders]: true,
    [FeatureFlag.BridgingFinance]: true,
    [FeatureFlag.CapitaliseInterest]: true,
    [FeatureFlag.OpportunityPlanner]: true,
    [FeatureFlag.Reverse]: true,
    [FeatureFlag.ServicingOverride]: true,
    [FeatureFlag.FactFind]: true,
    [FeatureFlag.FactFindTemplates]: false,
    [FeatureFlag.OpportunityDisclosureAutogen]: true
  },
  settings: {
    [FeatureFlag.Reports]: {
      [Report.Lending]: {}
    }
  },
  retryConfig: {
    maxRetries: 5,
    delayMs: 2000
  },
  ...generatedEnvironment
};
